export default {
  noData: 'No Data',
  nothingFound: 'Nothing found',
};
